<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUserAuthorizationsStore } from '@/store/UserAuthorizationsStore';
import { PACKAGE, HOTEL, AIR, MDT, CRUISE } from '@/constants';
import InputText from 'primevue/inputtext';

const props = defineProps<{
  emailData: object;
}>();

const emits = defineEmits<{
  handleOpenModal: [value: any];
  'update:emailData': [value: any];
}>();

const { t } = useI18n({ useScope: 'global' });
const userAuthorizationsStore = useUserAuthorizationsStore();
const authorizations: any = userAuthorizationsStore.permissionByRole;
const isDisable = computed(() => {
  return authorizations?.configurationPage?.configurable_items_edit;
});

const emailType = computed({
  get() {
    return props.emailData;
  },
  set(value) {
    emits('update:emailData', value);
  }
});

const handleOpenModal = (emailType: any, type: any, keyName: string) => {
  const payload = {
    emailType: emailType,
    type: type,
    keyName: keyName
  };
  emits('handleOpenModal', payload);
};

const getExclusionsTitle = (title: string) => {
  switch (title) {
    case 'airExp':
      return t('management.email.air_quote');
    case 'cruiseExp':
      return t('management.email.cruise_quote');
    case 'hotelExp':
      return t('management.email.hotel_quote');
    case 'mdtExp':
      return t('advance_quote.form.multi_day_tour');
    default:
      return t('management.email.package_quote');
  }
};

const getExclusionsType = (keyName: any) => {
  switch (keyName) {
    case 'airExp':
      return AIR;
    case 'cruiseExp':
      return CRUISE;
    case 'hotelExp':
      return HOTEL;
    case 'mdtExp':
      return MDT;
    default:
      return PACKAGE;
  }
};

const renderValueExpiryDate = (expiryDate: any) => {
  return Object.keys(expiryDate || {})
    .map((key) => `${key}(${expiryDate[key]})`)
    .join(' | ');
};
</script>
<template>
  <div class="flex mb-3 justify-content-between input-text-field">
    <div class="align-self-center mr-3 w-9rem">{{ getExclusionsTitle(emailType.keyName) }}</div>
    <InputText readonly :modelValue="renderValueExpiryDate(emailType?.exclusions)" class="mr-3"></InputText>
    <i v-if="isDisable" class="pi edit-pi pi-pencil cursor-pointer edit-icon" @click="handleOpenModal(emailType, getExclusionsType(emailType.keyName), emailType.keyName)"></i>
  </div>
</template>
